const isDev = import.meta.env.DEV;

export const logger = {
  info: (msg: string, data?: Record<string, unknown>) =>
    isDev && console.info(`[voltasis] ${msg}`, data ?? ''),
  warn: (msg: string, data?: Record<string, unknown>) =>
    isDev && console.warn(`[voltasis] ${msg}`, data ?? ''),
  error: (msg: string, data?: Record<string, unknown>) =>
    console.error(`[voltasis] ${msg}`, data ?? ''),
};
